<template>
  <v-sheet
    :height="size"
    :style="`max-width: ${size}px; width: ${size}px;`"
    color="var(--semi-opaque-overlay-bg-color)"
    rounded
    class="medium-icon d-flex rounded-pill align-center justify-center"
    ref="medium-icon"
  >
    <v-tooltip
      v-if="tooltip"
      color="var(--semi-opaque-overlay-bg-color)"
      open-delay="250"
      transition="fade-transition"
      :right="!text"
      :nudge-left="text ? 0 : 5"
      :bottom="!text"
      :nudge-top="text ? 5 : 0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon dark v-bind="attrs" v-on="on" :size="size * 0.8">{{ icon }}</v-icon>
      </template>

      <span>{{ name }}</span>
    </v-tooltip>

    <v-icon v-else dark :size="size * 0.8">{{ icon }}</v-icon>

    <div v-if="text !== ''" class="span-wrapper">
      <div class="favorite-title text-no-wrap mr-3">{{ text }}</div>
    </div>
  </v-sheet>
</template>

<style scoped>
.medium-icon {
  background-color: var(--semi-opaque-overlay-bg-color);

  transition:
    background-color 0.5s ease-in,
    max-width 0.5s ease-out;
}

.favorite-title {
  color: white;
}
</style>

<script>
import { userFriendlyMediumWord } from "../util/mediumHelpers";

export default {
  name: "medium-icon",

  props: {
    medium: { type: String, default: "" },

    size: { type: Number, default: 40 },

    tooltip: { type: Boolean, default: false },
    text: { type: String, default: "" },
  },

  computed: {
    name() {
      if (this.medium) return userFriendlyMediumWord(this.medium);
      else return "Unknown";
    },

    icon() {
      if (this.medium === this.$mediums.ALBUM) return "mdi-music";
      else if (this.medium === this.$mediums.PODCAST) return "mdi-microphone";
      else if (this.medium === this.$mediums.FILM) return "mdi-movie";
      else if (this.medium === this.$mediums.BOOK) return "mdi-book-open-variant";
      else if (this.medium === this.$mediums.TV_SHOW) return "mdi-television-classic";
      else return "mdi-help";
    },
  },

  data: () => ({}),
};
</script>
